import { useCreateManualFormModal } from '~/components/Modals/ManualFormModal';
import { useAppNavigation } from '~/hooks/nav.hook';
import { translate } from '~/utils/translation.utils';

export const usePurchaseByEmailInputModal = () => {
  const navigation = useAppNavigation();

  return useCreateManualFormModal({
    title: translate('purchases.purchasesForEmail'),
    subtitle: translate('purchases.enterEmail'),
    formData: [
      {
        items: [
          {
            type: 'email',
            label: translate('purchases.email'),
            id: 'email',
          },
        ],
      },
    ],
    onConfirm: (value) => {
      navigation.navigate('PurchasesByEmail', value);
    },
  });
};
